import i18n from '@i18n';
import * as yup from 'yup';

export const validationSchema = () =>
  yup.object({
    email: yup
      .string()
      .email(i18n.t('VALIDATION.EMAIL.VALID'))
      .required(i18n.t('VALIDATION.EMAIL.REQUIRED')),
    password: yup
      .string()
      .required(i18n.t('VALIDATION.NAME.REQUIRED'))
      .min(6, i18n.t('VALIDATION.PASSWORD.MIN')),
    first_name: yup.string().required(i18n.t('VALIDATION.NAME.REQUIRED')),
    role: yup.object().nullable(),
    active: yup.string().required(i18n.t('VALIDATION.REQUIRED')),
    phone: yup
      .string()
      .nullable()
      .matches(/^(\+|)(\d[0-9]{7,16})$/, i18n.t('VALIDATION.PHONE.FORMAT')),
  });
